module.exports = __webpack_public_path__ + "static/media/disableApp.d6808792.png";